import { FC } from "react";
import EmptyMiddlewareInstance from "./EmptyMiddlewareInstance";
import LoadingMiddlewareAnimTable from "./proto/LoadingMiddlewareAnim";

import { TableInputProps } from "../Table";
import { useSelector } from "react-redux";

const LoadingMiddlewareAnimInstance: FC<TableInputProps> = (props) => {
  const { isLoading } = useSelector((state: any) => state.rootReducer.user);

  if (isLoading.userData) {
    return <LoadingMiddlewareAnimTable {...props} />;
  } else {
    return <EmptyMiddlewareInstance {...props} />;
  }
};

export default LoadingMiddlewareAnimInstance;
